import React, { useEffect, useState } from 'react';

/**
 * TemizmamaYonetim: Temizmama konkuru yönetim sunumu (30 dk, 14 Eki 2026), temizmama-sunum'dan kısaltılmış ayrı deste.
 * Route: /r/temizmama-yonetim (sidebar YOK, tam ekran slayt).
 * Yeniden üretmek için: node src/pages/temizmama-yonetim/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır. Sunum modu da (F, tam ekran, #s13 hash'i)
 *    panel belgesine aynı origin'den erişiyor; sandbox onu da kırar. Betik build.js'te.
 * HTML modülü ~180KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function TemizmamaYonetim() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./temizmamaYonetimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Temizmama · Glowy"
      srcDoc={html}
      style={fill}
      allow="fullscreen"
      allowFullScreen
      // Ok tuşları ve Space ilk açılışta doğrudan desteye gitsin.
      onLoad={(e) => { try { e.currentTarget.contentWindow.focus(); } catch (err) { /* yok */ } }}
    />
  );
}
